import { createContext } from "react";
import { FormikErrors, FormikTouched, FormikValues } from "formik";
import {
  FormikHandleChangeTye,
  FormikSetFieldValueType,
} from "../configs/DeclareTypes";
import { DropdownItemProps } from "semantic-ui-react";

type Props = {
  values: FormikValues;
  errors: FormikErrors<FormikValues>;
  touched: FormikTouched<FormikValues>;
  isSubmitting: boolean;
  handleChange: FormikHandleChangeTye;
  setFieldValue: FormikSetFieldValueType;
  currencyOptions: DropdownItemProps[];
  timezoneOptions: DropdownItemProps[];
};
export const CampaignCreateEditContext = createContext<Props>({
  values: {},
  errors: {},
  touched: {},
  isSubmitting: false,
  handleChange: () => null,
  setFieldValue: () => null,
  currencyOptions: [],
  timezoneOptions: [],
});
